import React, { Component } from 'react';
//components

const Decades = (props) => {
    var onSelectDecade = (decade) => {
        if (typeof props.closeMenu === 'function')
            props.closeMenu();
        if (typeof props.setSelectTransform === 'function')
            props.setSelectTransform();
        window.location.href = `./#/decade/${decade}`;
        props.sendGA("Decade_Clicked", decade);
    }

    let options = [];
    let year = 1948;
    for (let i = 1; i < props.decadesJSON.length + 1; i++) {
        options.push(
            <div key={i} className={props.currentDecade != null && i === (props.currentDecade + 1) ? "years-select selected" : "years-select"}>
                <div className="options" value={i} onClick={() => onSelectDecade(i)}>
                    {props.decadesJSON[i - 1].title}
                    <span> {props.decadesJSON[i - 1].years}</span>
                </div>
                {i === (props.decadesJSON.length) ? "" : <div className="line"></div>}
            </div>)
        year += 10;
    }
    return (
        <div className="select-div" style={{ "transform": "translateY(" + (props.showSelectTransform ? "0" : "-150") + "%)" }}>
            {options}
        </div>
    )
}

class DecadesYears extends Component {
    render() {
        return (
            <Decades
                decadesJSON={this.props.decadesJSON}
                showSelectTransform={this.props.showSelectTransform}
                currentDecade={this.props.currentDecade}
                closeMenu={this.props.closeMenu}
                setSelectTransform={this.props.setSelectTransform}
                sendGA={this.props.sendGA}
            />
        );
    }
}

export default DecadesYears;



// WEBPACK FOOTER //
// ./src/Components/DecadesYears/DecadesYears.js